//import React, {useState} from "react";
import { useAuth } from '../../../provider'
import { useNavigate, useLocation } from "react-router-dom";
import { Link as RouterLink } from 'react-router-dom';
import * as api from '../../../Auth/auth'
import Link from '@mui/material/Link';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
//import Stack from '@mui/material/Stack';
import ButtonsMain from "../../../components/Button/ButtonMain";
import CancerActions from "./CancerActions";
import Dia_Info from "./Dia_Info";


export default function DiagroupCancer() {

    const { state, handleLogout } = useAuth();
  
    let navigate = useNavigate();
    let location = useLocation();
  
    const handleLogoutapi = async () => {
      let response = await api.logout()
      await handleLogout(response);
       GoTo()
  }
  
  let from = location.state?.from?.pathname || "/";
     const GoTo = () => { navigate(from, { replace: true }) }
 
  return (
<>
    <Grid container sx={{mt: {xs:'2rem', }, justifyContent: 'center'}}>   
               
           <CancerActions /> 
     
    </Grid>

</>
  )
}